import { useEffect, useState } from 'react';

const getOnLineStatus = () =>
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;

export const useNavigatorOnLine = () => {
    const [status, setStatus] = useState(getOnLineStatus());

    const setOnline = () => {
        setStatus(true);
    };
    const setOffline = () => {
        setStatus(false);
    };

    useEffect(() => {
        globalThis.addEventListener('online', setOnline);
        globalThis.addEventListener('offline', setOffline);

        return () => {
            globalThis.removeEventListener('online', setOnline);
            globalThis.removeEventListener('offline', setOffline);
        };
    }, []);

    return status;
};
